import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import { PlusCircleIcon } from '@/icons';

export const StyledContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 6rem;
  gap: 2rem;
`;

export const StyledAddVariationButton = styled(Button)`
  &&& {
    height: 2.5rem;
    background-color: ${COLORS.YELLOW_PRIMARY};
    border-color: transparent;

    &&&:hover {
      background-color: ${COLORS.YELLOW_PRIMARY};
    }
  }
`;

export const StyledContainerTitle = styled.div`
  ${pickThemeFontStyles('20', '30', 'NORMAL')};
  color: ${COLORS.BLACK};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;

  && .ant-table-wrapper {
    width: 100%;
  }
`;

export const StyledPlusCircleIcon = styled(PlusCircleIcon)`
  width: 1.5rem;
  height: 1.5rem;
  &&& path:first-of-type {
    stroke: ${COLORS.BLACK_PRIMARY};
  }
  &&& path:nth-child(2),
  path:last-of-type {
    fill: ${COLORS.BLACK_PRIMARY};
  }
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('24', '30', 'NORMAL')};
  margin-bottom: 1rem;
`;

export const StyledSubTitleModal = styled.p`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  margin-bottom: 1.5rem;
  color: ${COLORS.CHARCOAL};
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      ${pickThemeFontStyles('14', '22', 'NORMAL')};
      width: 100%;
      color: ${COLORS.WHITE};
    }
  }
`;

export const StyledBackButton = styled(Button)`
  &&& {
    background-color: ${COLORS.WHITE};
    color: ${COLORS.BLACK_PRIMARY} !important;
  }
`;
